'use client';

import { useState } from 'react';
import Link from 'next/link';

export default function CvButtonJob() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link href="/register">
      <button
        type="button"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`group relative inline-flex w-full max-w-[300px] items-center gap-2 overflow-hidden rounded-none border-2 border-white bg-transparent px-[10px] py-[13px] text-base font-semibold leading-normal tracking-wide text-white transition-all duration-500 ease-in-out md:max-w-[380px] ${
          isHovered
            ? 'before:origin-left before:scale-x-100'
            : 'before:origin-left before:scale-x-0'
        } before:absolute before:inset-0 before:z-0 before:bg-white before:transition-transform before:duration-500`}
      >
        <span className="relative z-10 flex w-full items-center justify-between">
          <div className="w-[28px]"></div>
          <div className="flex items-center gap-2">
            <svg
              width="18"
              height="27"
              viewBox="0 0 18 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`h-[27px] w-[18px] transition-colors duration-1000 ${
                isHovered ? 'text-[#D70C18]' : 'text-white'
              }`}
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.34861 0.621094C1.72572 0.621094 1.12834 0.868536 0.687893 1.30899C0.247442 1.74944 0 2.34682 0 2.96971V20.1929C0 20.8158 0.247443 21.4132 0.687893 21.8536C1.12834 22.2941 1.72572 22.5415 2.34861 22.5415H10.7002V20.9758H2.34861C2.14098 20.9758 1.94186 20.8933 1.79504 20.7465C1.64822 20.5996 1.56574 20.4005 1.56574 20.1929V2.96971C1.56574 2.76208 1.64822 2.56295 1.79504 2.41613C1.94186 2.26932 2.14098 2.18684 2.34861 2.18684H14.8746C15.0822 2.18684 15.2813 2.26932 15.4281 2.41613C15.5749 2.56295 15.6574 2.76208 15.6574 2.96971V16.7207L17.2232 17.0252V2.96971C17.2232 2.34682 16.9757 1.74944 16.5353 1.30899C16.0948 0.868536 15.4974 0.621094 14.8746 0.621094H2.34861ZM3.91436 5.31832C3.48199 5.31832 3.13149 5.66883 3.13149 6.10119C3.13149 6.53356 3.48199 6.88407 3.91436 6.88407H7.04584C7.47821 6.88407 7.82871 6.53356 7.82871 6.10119C7.82871 5.66883 7.47821 5.31832 7.04584 5.31832H3.91436ZM3.91436 10.7984C3.48199 10.7984 3.13149 11.1489 3.13149 11.5813C3.13149 12.0137 3.48199 12.3642 3.91436 12.3642H13.3088C13.7412 12.3642 14.0917 12.0137 14.0917 11.5813C14.0917 11.1489 13.7412 10.7984 13.3088 10.7984H3.91436ZM3.91436 13.9299C3.48199 13.9299 3.13149 14.2804 3.13149 14.7128C3.13149 15.1451 3.48199 15.4957 3.91436 15.4957H13.3088C13.7412 15.4957 14.0917 15.1451 14.0917 14.7128C14.0917 14.2804 13.7412 13.9299 13.3088 13.9299H3.91436ZM3.91436 17.0614C3.48199 17.0614 3.13149 17.4119 3.13149 17.8443C3.13149 18.2766 3.48199 18.6271 3.91436 18.6271H7.04584C7.47821 18.6271 7.82871 18.2766 7.82871 17.8443C7.82871 17.4119 7.47821 17.0614 7.04584 17.0614H3.91436ZM13.7003 6.10119C13.7003 6.31738 13.525 6.49263 13.3088 6.49263C13.0926 6.49263 12.9174 6.31738 12.9174 6.10119C12.9174 5.88501 13.0926 5.70976 13.3088 5.70976C13.525 5.70976 13.7003 5.88501 13.7003 6.10119Z"
                fill="currentColor"
              />
              <path
                d="M13.9616 22.404L14.8698 21.7151L15.774 22.404L15.4295 21.2884L16.3377 20.5682H15.226L14.8698 19.4682L14.5136 20.5682H13.4019L14.3061 21.2884L13.9616 22.404ZM18.0013 20.9596C18.0013 19.2295 16.5999 17.8281 14.8698 17.8281C13.1396 17.8281 11.7383 19.2295 11.7383 20.9596C11.7383 21.7542 12.0358 22.4745 12.5212 23.0264V26.0483L14.8698 25.2654L17.2184 26.0483V23.0264C17.7231 22.4563 18.0016 21.7211 18.0013 20.9596ZM14.8698 18.611C16.1654 18.611 17.2184 19.664 17.2184 20.9596C17.2184 22.2553 16.1654 23.3082 14.8698 23.3082C13.5741 23.3082 12.5212 22.2553 12.5212 20.9596C12.5212 19.664 13.5741 18.611 14.8698 18.611Z"
                fill="currentColor"
              />
            </svg>
            <span
              className={`transition-colors duration-1000 ${
                isHovered ? 'text-[#D70C18]' : 'text-white'
              }`}
            >
              登録して求人を見る
            </span>
          </div>
          <svg
            viewBox="0 0 28 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`h-[24px] w-[28px] transition-colors duration-1000 ${
              isHovered ? 'text-[#D70C18]' : 'text-white'
            }`}
          >
            <path
              d="M18.5 7L24.5 13H2"
              stroke="currentColor"
              strokeWidth="1.5"
            />
          </svg>
        </span>
      </button>
    </Link>
  );
}
